// extracted by mini-css-extract-plugin
module.exports = {"track-title__title":"track-title_track-title__title__bYxIS","track-title__title-mobile":"track-title_track-title__title-mobile__EzkuZ"};